import { REPORT_PAGES_ROUTES } from "./routeConstants";
export const SDLC_REPORT_HEADER_LENGTH = 8;
export const DIFF_REPORT_HEADER_LENGTH = 8;
export const CHECKS_REPORT_HEADER_LENGTH = 8;
export const SDLC_REPORT_SIGNATURE = "SDLC";
export const DIFF_REPORT_SIGNATURE = "DIFF";
export const CHECKS_REPORT_SIGNATURE = "CHEK";
/** Sticky header height for SDLC report tabs */
export const headerHeight = 72;
/** UI element IDs */
export const tabsHeaderID = "tabs-header";
export const sbomID = "sbom-table";
export const vulnerabilitiesID = "vulnerabilities-table";
export const issuesID = "issues-table";
export const filesDiffID = "files-diff-table";
export const reproID = "reproducibility-tab-header";
export const ROOT_FILE_PATH = "<Submitted Package>";
/** String used to represent empty publisher string */
export const EMPTY_PUBLISHER = "Unknown publisher";
export const ISSUES_COLUMN_WIDTH = "185px";
export const COMPONENT_LIST_INIT_SORT = {
    property: "grade",
    reverse: true,
};
export const EFFORT_TO_ESTIMATE = {
    high: 8,
    medium: 4,
    low: 2,
};
export const COMPONENT_UNKNOWN_YEAR = "";
export const CHECK_TYPE_TO_ROUTE = {
    "VERSION-REPORT": REPORT_PAGES_ROUTES.ISSUES_ROUTE,
    "VERSION-DIFF": REPORT_PAGES_ROUTES.VERSION_DIFF,
    "REPRO-REPORT": REPORT_PAGES_ROUTES.REPRODUCIBILITY_ROUTE,
    "REPRO-DIFF": REPORT_PAGES_ROUTES.REPRODUCIBILITY_ROUTE,
    "REPRO-CHECK": REPORT_PAGES_ROUTES.REPRODUCIBILITY_ROUTE,
};
//# sourceMappingURL=common.js.map